import Modal from "@mui/material/Modal";
import { makeStyles } from "../AppContainer/mui-theme";
import _, { get } from "lodash";
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Button from "../Button";
import ServingOptionsIcon from "../serving-option-icon";
import * as styles from "./index.module.scss";
import { closeNewOrPrevOrderModal } from "../../store/app/actions";
import { startNewOrder, setFeaturedProductToByInOrder } from "../../store/order/actions";
import { selectGift } from "../../store/giftRedeem/actions";
import { navigateTo, setParams } from "../../utils/location";

export default ({ appStyles, T, pageContext }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  
  const app = useSelector((state) => state.app);
  const order = useSelector((state) => state.order);
  
  const { servingOptions = [], branches = [], menuData } = pageContext || {};
  const { servingOptionType, branchId } = order;
  
  const orderSelectedServingOption = _.find(servingOptions, { type: servingOptionType }) || {};
  const orderSelectedBranch = _.find(branches, { id: branchId }) || {};
  
  const { context, giftToRedeem, featuredProductId } = app.newOrPrevOrderModalPayload || {};
  
  const servingOptionTag = _.toLower(orderSelectedServingOption.servingOptionTag);
  
  const skipServingOptionsPage = get(appStyles, "skipServingOptionsPage", false);
  
  const navigateToNewOrder = () => {
    const path = skipServingOptionsPage || servingOptions.length < 2 
      ? "/find-location" 
      : "/serving-options";
    navigateTo(path);
  };

  const handleCloseModal = () => {
    dispatch(closeNewOrPrevOrderModal());
  };

  const handleChooseNewOrder = () => {
    dispatch(closeNewOrPrevOrderModal());
    dispatch(startNewOrder());
    
    switch (context) {
      case 'gifts':
        if (giftToRedeem) {
          dispatch(selectGift(giftToRedeem));
        }
        break;
      case 'coupons':
        if (giftToRedeem) {
          dispatch(selectGift(giftToRedeem, menuData));
        }
        break;
      case 'featured':
        if (featuredProductId) {
          dispatch(setFeaturedProductToByInOrder(featuredProductId));
        }
        navigateToNewOrder();
        break;
      case 'homepage':
      case 'navigation':
      default:
        navigateToNewOrder();
        break;
    }
  };

  const handleChooseContinueOrder = () => {
    dispatch(closeNewOrPrevOrderModal());
    
    switch (context) {
      case 'gifts':
        if (giftToRedeem) {
          dispatch(selectGift(giftToRedeem));
        } else {
          navigateTo(setParams("/order", _.pick(order, ["branchId", "servingOptionType"])));
        }
        break;
      case 'coupons':
        if (giftToRedeem) {
          dispatch(selectGift(giftToRedeem, menuData));
        }
        break;
      case 'featured':
        if (featuredProductId) {
          dispatch(setFeaturedProductToByInOrder(featuredProductId));
        }
        navigateTo(`/order/items/${featuredProductId}`); 
        break;
      case 'homepage':
      case 'navigation':
      default:
        navigateTo(setParams("/order", { branchId }));
        break;
    }
  };

  return (
    <Modal
      open={app.isOpenNewOrPrevOrderModal}
      onClose={handleCloseModal}
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      className={classes.modal}
      closeAfterTransition
    >
      <div
        className={classes.paper}
        style={{
          direction: appStyles.rtl && "rtl",
          ...(appStyles.bodyFont && { fontFamily: appStyles.bodyFont }),
          ...(appStyles.bodyFontWeight && {
            fontFamily: appStyles.bodyFontWeight,
          }),
          borderRadius: 5,
          color: _.get(appStyles, "Card.color", appStyles.textColor),
        }}
      >
        <div
          style={{ color: appStyles.actionColor }}
          className={styles.SVGWrapper}
        >
          {orderSelectedServingOption && orderSelectedServingOption.type && (
            <ServingOptionsIcon
              appStyles={appStyles}
              servingOption={orderSelectedServingOption.type}
            />
          )}
        </div>
        <div
          id="modal-title"
          style={{ textAlign: "center",
            ...get(appStyles, "StartNewOrderPopupTitle.color") ? {color: get(appStyles, "StartNewOrderPopupTitle.color")} : {},
           }}
          role="heading"
          aria-level="1"
        >{`${T(
          `${T(`We noticed that you are ordering`)} ${servingOptionTag} ${T(
            "from",
          )}`,
        )} ${orderSelectedBranch.name}`}</div>
        <div
          style={{
            ...appStyles.StartNewOrderPopupTitle,
            textAlign: "center",
            margin: "16px 0",
          }}
          role="heading"
          id="modal-description"
          aria-level="2"
        >
          {T(`What would you like to do?`)}
        </div>
        <div>
          <Button
            appStyles={appStyles}
            centered
            style={{ marginBottom: 20 }}
            onClick={handleChooseContinueOrder}
          >
            {T("Continue order")}
          </Button>
          <Button
            linkStyle
            appStyles={appStyles}
            style={{ paddingBottom: 10, paddingTop: 10 }}
            centered
            onClick={handleChooseNewOrder}
          >
            {T("Start new order")}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

const useStyles = makeStyles()((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));
